export const rowsForBrowserInfoSkeleton = [
  "Type",
  "User Agent",
  "JavaScript",
  "VBScript",
  "Flash",
  "Java",
  "Screen",
  "Plugins",
];
